/**
 * Hits Component
 */
import React, { Component } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import PropTypes from 'prop-types'
import Scrollbars from 'react-custom-scrollbars'
import { ShowProductImages, ScrollbarsContainer } from './styled'
import { sendGenericEvent } from '../../../common/GoogleTagManager'
import constants from '../../../common/constants'
import './desktop.css'
import AttributeTag from '../../../functional-components/Tags/components/AttributeTag'
import CampaignTag from '../../../functional-components/Tags/components/CampaignTag'
import ImageWrapper from './ImageWrapper'
import { setURLParams, getImageSizeAndFormatParams } from '../../../Helpers/imageHelper.js'

class DesktopImagePreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imageToShow: 0,
      backgroundPosition: '0% 0%',
      backgroundImage: '',
      imageExists: true,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { images } = this.props
    const { images: prevImages } = prevProps
    const { imageToShow } = prevState
    const { imageToShow: stateImageToShow } = this.state

    if (stateImageToShow !== imageToShow) {
      const imgParams = getImageSizeAndFormatParams(images[stateImageToShow], 2000)
      this.setSelectedImage(`url(${setURLParams(images[stateImageToShow], imgParams)})`)
    }

    if (prevProps && prevImages && JSON.stringify(prevImages) !== JSON.stringify(images)) {
      this.getImageToShow()
    }
  }

  setSelectedImage = (image) => {
    this.setState({
      backgroundImage: image,
    })
  }

  showProductImages = () => {
    const { images, hit } = this.props
    return images.map((image, ix) => (
      <ShowProductImages
        key={`product-${ix}`}
        className="mb-10 mr-10"
        onClick={() => {
          this.handleImageToShow(ix)
        }}
        onKeyPress={() => {
          this.handleImageToShow(ix)
        }}
      >
        <ImageWrapper>
          <LazyLoadImage src={image} height={50} alt={`${hit.brand} - ${hit.displayName}`} />
        </ImageWrapper>
      </ShowProductImages>
    ))
  }

  handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect()
    const x = ((e.pageX - left) / width) * 100
    const y = ((e.pageY - top) / height) * 100
    this.setState({ backgroundPosition: `${x}% ${y}%` })
  }

  handleMouseOut = () => {
    this.setState({ backgroundPosition: '0% 0%' })
  }

  handleImageToShow = (ix) => {
    this.setState({ imageToShow: ix })
  }

  getImageToShow = () => {
    const {
      hit: { sku },
      images,
    } = this.props
    const { imageToShow } = this.state

    if (images[imageToShow]) {
      const imgParams = getImageSizeAndFormatParams(images[imageToShow], 2000)
      this.setState({
        backgroundImage: `url(${setURLParams(images[imageToShow], imgParams)})`,
        imageExists: true,
      })
      return
    }

    this.setState({
      backgroundImage: `url(${constants.PRODUCT_WITHOUT_IMAGE})`,
      imageExists: false,
    })
    sendGenericEvent('product-with-no-photo', { sku })
  }

  componentDidMount = () => {
    this.getImageToShow()
  }

  render() {
    const { images, hit } = this.props
    const { backgroundPosition, backgroundImage, imageExists } = this.state
    const showGallery = images && imageExists
    const desktopStyleObj =
      backgroundPosition === '0% 0%'
        ? {
            backgroundImage,
            backgroundPosition: 'center',
            backgroundSize: 'contain',
          }
        : {
            backgroundImage,
            backgroundPosition,
          }

    return (
      <div className={`desktop__container${!showGallery ? ' desktop__container-no-gallery' : ''}`}>
        {showGallery && (
          <ScrollbarsContainer>
            <Scrollbars className="desktop__scrollbars" autoHide>
              {this.showProductImages()}
            </Scrollbars>
          </ScrollbarsContainer>
        )}
        <div className="image-preview__figure-wrapper">
          <figure
            className="desktop__primary-image-container"
            style={desktopStyleObj}
            onMouseMove={this.handleMouseMove}
            onMouseOut={this.handleMouseOut}
            onBlur={this.handleMouseOut}
          />
          <CampaignTag
            tags={hit.tags}
            isAvailable={hit.available}
            classNames="tags__campaign-tag-container--absolute"
          />
          <AttributeTag
            tags={hit.tags}
            isAvailable={hit.available}
            classNames="tags__attribute-tag-container--absolute"
          />
        </div>
      </div>
    )
  }
}

export default DesktopImagePreview

DesktopImagePreview.defaultProps = {
  hit: {},
  images: [],
  walmartExclusive: false,
}

DesktopImagePreview.propTypes = {
  hit: PropTypes.object,
  images: PropTypes.array,
  walmartExclusive: PropTypes.bool,
}
